<template>
  <div class="Survey">
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane label="服务评价">
        <span slot="label"> 服务评价 </span>
        <el-divider content-position="left">填写服务评价</el-divider>
        <div class="info-background">
          <el-form class="rule-form" ref="ruleForm">
            <div class="survey-div">处理结果
              <div class="msg-div">
                <el-collapse-transition>
<!--                  <div v-if="surveyForm.processResult=='' && showMsg" class="rule-msg">-->
<!--                    （请选择）-->
<!--                  </div>-->
                </el-collapse-transition>
              </div>
            </div>
            <el-radio v-model="surveyForm.processResult" label="已解决" class="survey-radio"></el-radio>
            <el-radio v-model="surveyForm.processResult" label="未解决" class="survey-radio"></el-radio>

            <div v-if="surveyForm.processResult=='已解决'">
              <div class="survey-div">是否按约定时间上门
                <div class="msg-div">
                  <el-collapse-transition>
                    <div v-if="surveyForm.appTimeService=='' && showMsg" class="rule-msg">
                      （请选择）
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <el-radio v-model="surveyForm.appTimeService" label="按时" class="survey-radio"></el-radio>
              <el-radio v-model="surveyForm.appTimeService" label="未按时" class="survey-radio"></el-radio>

              <div class="survey-div">是否可以正常使用
                <div class="msg-div">
                  <el-collapse-transition>
                    <div v-if="surveyForm.useProblem=='' && showMsg" class="rule-msg">
                      （请选择）
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <el-radio v-model="surveyForm.useProblem" label="是" class="survey-radio"></el-radio>
              <el-radio v-model="surveyForm.useProblem" label="否" class="survey-radio"></el-radio>

              <div class="survey-div">您的评分
                <div class="msg-div">
                  <el-collapse-transition>
                    <div v-if="surveyForm.visitResult==0 && showMsg" class="rule-msg">
                      （请打分）
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <el-rate
                  v-model="surveyForm.visitResult" text-color="#ff9900">
              </el-rate>


              <div class="survey-div">您的意见
                <div class="msg-div">
                  <el-collapse-transition>
                    <div v-show="surveyForm.visitResult <= 3 && surveyForm.customerAdvice == '' && showMsg" class="rule-msg">
                      （请说明原因）
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请留下您的宝贵意见.."
                  maxlength="300"
                  show-word-limit
                  v-model="surveyForm.customerAdvice"
                  style="margin: 0px 15px">
              </el-input>
            </div>

            <div v-if="surveyForm.processResult=='未解决'">
              <div class="survey-div">是否需要再次上门
                <div class="msg-div">
                  <el-collapse-transition>
                    <div v-if="surveyForm.revisit=='' && showMsg" class="rule-msg">
                      （请选择）
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <el-radio v-model="surveyForm.revisit" label="是" class="survey-radio"></el-radio>
              <el-radio v-model="surveyForm.revisit" label="否" class="survey-radio"></el-radio>
              <div class="survey-div">请问是什么原因导致未解决
                <div class="msg-div">
                  <el-collapse-transition>
                    <div v-show="surveyForm.visitInfo == '' && showMsg" class="rule-msg">
                      （请说明原因）
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请说明.."
                  maxlength="300"
                  show-word-limit
                  v-model="surveyForm.visitInfo"
                  style="margin: 0px 15px">
              </el-input>
            </div>

          </el-form>
<!--          <el-button class="savebtn" type="primary" @click="subbmit">提交评价</el-button>-->
          <el-button v-if="surveyForm.processResult!=''" class="savebtn" type="primary" @click="subbmit">提交评价</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
    import wx from 'weixin-js-sdk'

    export default {
        name: "Survey",
        data() {
            return {
                showMsg: false,
                solved: true,
                // 服务评价
                surveyForm: {
                    incidentId: '',         // RN工单id
                    processResult: '',      // 处理结果
                    // 已解决显示字段
                    appTimeService: '',     // 是否按约定时间上门
                    useProblem: '',         // 使用有无问题
                    visitResult: 0,         // 用户评分
                    customerAdvice: '',     // 意见
                    // 未解决显示字段
                    revisit: '',            // 是否需要再次上门
                    visitInfo: '',          // 未解决原因
                }
            }
        },
        created() {
            // 正式
            this.surveyForm.incidentId = this.$route.query.incidentId;

            // 测试
            // this.surveyForm.incidentId = 92987;

            if(this.surveyForm.incidentId){
                this.$axios.get(this.$baseURL + `/incident/surveyed/`+this.surveyForm.incidentId)
                    .then((response)=> {
                        if(response.data == true){
                            this.$confirm('请勿重复评价！', '', {
                                confirmButtonText: '确定',
                                showCancelButton: false,
                                type: 'waring',
                                showClose: false,
                                customClass: 'message-logout'
                            }).then(() => {
                                // 提交成功点击确定，刷新页面
                                console.log("closed");
                                wx.closeWindow();
                            }).catch(() => {
                                // DO NOTHING
                            });
                        }
                    })
                    .catch(error=> {
                        console.log(error);
                        this.$message({
                            type: 'warning',
                            message: '提交失败，请重试或联系客服',
                            offset: 60
                        });
                        this.loading = false;
                    });
            }else {
                this.$confirm('系统异常，请重试或联系客服', '', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'waring',
                    showClose: false,
                    customClass: 'message-logout'
                }).then(() => {
                    console.log("closed");
                    wx.closeWindow();
                }).catch(() => {
                    // DO NOTHING
                });
            }
        },
        methods: {
            subbmit() {
                if(this.surveyForm.processResult == '已解决'){
                    this.solved = true
                }else if(this.surveyForm.processResult == '未解决'){
                    this.solved = false
                }else {
                    this.showMsg = true;
                    return;
                }
                if(this.solved == true && (this.surveyForm.processResult == '' || this.surveyForm.appTimeService == '' || this.surveyForm.useProblem == '' || this.surveyForm.visitResult == 0)){
                    this.showMsg = true;
                    return;
                }
                if(this.solved == true && (this.surveyForm.visitResult <= 3 && this.surveyForm.customerAdvice == '')){
                    this.showMsg = true;
                    return;
                }
                if(this.solved == false && (this.surveyForm.revisit == '' || this.surveyForm.visitInfo == '')){
                    this.showMsg = true;
                    return;
                }
                // console.log(this.surveyForm);
                // 提交评价
                this.$axios.post(this.$baseURL + `/incident/survey`,this.$qs.stringify(this.surveyForm))
                    .then(()=> {
                        console.log("评价成功！");
                        this.$confirm('感谢您的反馈！', '', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'success',
                            showClose: false,
                            customClass: 'message-logout'
                        }).then(() => {
                            // 提交成功点击确定，刷新页面
                            console.log("closed");
                            wx.closeWindow();
                            // window.close();
                            // this.$router.push({
                            //     name:"Auth",
                            // })
                        }).catch(() => {
                            // DO NOTHING
                        });
                        this.loading = false;
                    })
                    .catch(error=> {
                        console.log(error);
                        this.$message({
                            type: 'warning',
                            message: '提交失败，请重试或联系客服',
                            offset: 60
                        });
                        this.loading = false;
                    });
            }
        }
    };
</script>

<style scoped>

  .el-radio {
    margin: 10px 30px;
  }

  .rule-form {
    padding: 0px 20px;
    font-size: 13px;
  }

  .savebtn {
    margin: 40px 0 20px 0;
  }
  .survey-div {
    margin: 20px 15px 10px 15px;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
  }
  .rule-msg {
    float: left;
    font-size: 13px;
    font-weight: 500;
    color: #F56C6C;
    display: inline-block;
  }
  .msg-div {
    position: relative;
    top: 2px;
    height: 17px;
    display: inline-block;
  }
</style>
<style>
  .el-radio:first-child {
    margin-right: 30px!important;
  }
  .el-radio:last-child {
    margin-right: 30px!important;
  }
  .survey-radio {
    width: 70px!important;
    text-align: left!important;
  }
</style>
